export default __webpack_public_path__ + "static/media/shifa.7fda2e8e.png";